import axios from "axios"
import { queryFixer } from "common/utils/utils"

export const getListadoUsuarioPaginated = (queryState: $TSMigrationFixMe) => {
  const url = queryFixer(`/Usuario/by-filters`, queryState)

  return axios.get(url)
}
